export function GoogleMark() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path fill="#4285f4" d="M21.6 12.2c0-.7-.1-1.5-.2-2.2H12v4.2h5.4a4.6 4.6 0 0 1-2 3v2.7h3.4c2-1.8 2.8-4.5 2.8-7.7Z" />
      <path fill="#34a853" d="M12 22c2.8 0 5.2-.9 6.9-2.5l-3.4-2.7c-.9.6-2.1 1-3.5 1-2.7 0-5-1.8-5.8-4.3H2.7v2.8A10.4 10.4 0 0 0 12 22Z" />
      <path fill="#fbbc05" d="M6.2 13.5a6.2 6.2 0 0 1 0-4V6.7H2.7a10.4 10.4 0 0 0 0 9.6l3.5-2.8Z" />
      <path fill="#ea4335" d="M12 5.2c1.5 0 3 .5 4 1.6l3-3A10 10 0 0 0 2.7 6.7C7 7 9.3 5.2 12 5.2Z" />
    </svg>
  );
}
